import { Component, Input } from '@angular/core';
import { ActionConfig, type ActionDto, ActionModal, ModalService, WebAppCommonModule } from "@allbesmart/web-app-common";
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";

@Component({
    selector: 'oaibox-flexric-upgrade-config-action-modal',
    templateUrl: './flexric-upgrade-config-action-modal.component.html',
    styleUrls: ['./flexric-upgrade-config-action-modal.component.css'],
    imports: [WebAppCommonModule, ReactiveFormsModule]
})
export class FlexricUpgradeConfigActionModalComponent implements ActionModal {

  @Input({required: true}) public actionConfig!: ActionConfig;
  @Input({required: true}) public sendAction!: (actionDto: FlexRicUpgradeActionDto) => void;

  public versionForm: FormGroup<{ version: FormControl<string | null> }>;

  constructor(private modalService: ModalService) {
    this.versionForm = new FormGroup<{ version: FormControl<string | null> }>({
      version: new FormControl<string | null>(null, [Validators.required])
    });
  }

  public confirmAction(): void {
    if (this.versionForm.valid && this.versionForm.value.version) {
      this.sendAction({
        type: this.actionConfig.type,
        command: this.actionConfig.command,
        configuration: {branch: this.versionForm.value.version},
      });
      this.modalService.popModal();
    }
  };

  protected cancel(): void {
    this.modalService.popModal();
  }

}

export interface FlexRicUpgradeActionDto extends ActionDto {
  configuration?: { branch: string; }
}

